import React, { useState } from 'react'
import MarkerIcon from '../../../../asset/Waypoint_Dk_Green.png'
import MapCenterIcon from '../../../../asset/Map-Center_Solid_589500_ldpi.png'
import { markerAction } from '../../../action/center-marker-action'
import { connect } from 'react-redux'
import './index.css'

const Geolocation = (props) => {
  const [lat, setlatitude] = useState(null)
  const [lng, setlongitude] = useState(null)
  let markerData = null

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setlatitude(latitude)
          setlongitude(longitude)
          let coords = new google.maps.LatLng(latitude, longitude)
          props.mapReference.setCenter(coords)
          props.mapReference.setZoom(17)
          if (!props.markerCenter || props.markerCenter) {
            if (!props.markerCenter) {
              markerData = new window.google.maps.Marker({
                position: coords,
                map: props.mapReference,
                title: 'Your Location',
                icon: {
                  url: MarkerIcon,
                },
                clickable: false,
              });
              props.markerAction({ markerObj: markerData, coords: { latitude: latitude, longitude: longitude } })
            } else if (props.markerCenter && props.markerCenter.mapObj) {
              markerData = new window.google.maps.Marker({
                position: coords,
                map: props.mapReference,
                title: 'Your Location',
                icon: {
                  url: MarkerIcon,
                },
                clickable: false,
              });
              props.markerAction({ markerObj: markerData, coords: { latitude: latitude, longitude: longitude } })
            }
          }
        },
        (error) => {
          if (error.code === error.PERMISSION_DENIED) {
            console.warn('Geolocation permission denied by user.');
          } else {
            console.warn('Error getting location:', error.message);
          }
        }
      );
    } else {
      console.warn('Geolocation is not supported by your browser');
    }
  };


  return (
    <div>
      <div className='geolocation-container'
        style={{ backgroundImage: `url(${'../../../../asset/Map-Center_Solid_589500_ldpi.png'})` }}
        onClick={() => {
          getLocation()
        }}
      >
      </div>
    </div>
  )
}


const mapStateToProps = state => ({
  weatherValue: state.weatherValue,
  mapReference: state.mapReference(),
  markerCenter: state.markerCenter
})

const mapDispatchToProps = dispatch => ({
  markerAction: payload => dispatch(markerAction(payload))
})
export default connect(mapStateToProps, mapDispatchToProps)(Geolocation)

